var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-button no-print selector-radio",on:{"click":_vm.print}},[_c('font-awesome-icon',{attrs:{"icon":"print"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }